export default {"src":"/uk/_next/static/media/planInfoIcon.de62347f.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};